import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalComponent} from "./modal/modal.component";
import {AppHeaderComponent} from "./app-header/app-header.component";
import {AppFooterComponent} from "./app-footer/app-footer.component";
import {AcceptableUsePolicyComponent} from "./app-footer/footer-pages/acceptable-use-policy/acceptable-use-policy.component";
import {CookiePolicyComponent} from "./app-footer/footer-pages/cookie-policy/cookie-policy.component";
import {DisclaimerComponent} from "./app-footer/footer-pages/disclaimer/disclaimer.component";
import {PrivacyPolicyComponent} from "./app-footer/footer-pages/privacy-policy/privacy-policy.component";
import {TermsOfUseComponent} from "./app-footer/footer-pages/terms-of-use/terms-of-use.component";
import {KebabMenuComponent} from "./kebab-menu/kebab-menu.component";
import { CustomMenuComponent } from './custom-menu/custom-menu.component';
import { CustomMenuItemComponent } from './custom-menu/custom-menu-item/custom-menu-item.component';
import { FormComponentsModule } from '@synx/form-components';
import { FreeSearchComponent } from './free-search/free-search.component';
import { CustomDropdownListContainerComponent } from './custom-dropdown-list-container/custom-dropdown-list-container.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMultiSelectComponent } from './custom-multi-select/custom-multi-select.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { CustomTextInputComponent } from './custom-text-input/custom-text-input.component';
import { CustomTooltipComponent } from './custom-tooltip/custom-tooltip.component';
import { MenuTabsComponent } from './menu-tabs/menu-tabs.component';
import { RouterModule } from '@angular/router';
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { XYGraphComponent } from './x-y-graph/x-y-graph.component';
import { CustomSortDirective } from './custom-sort/custom-sort.directive';
import { CustomSortHeaderComponent } from './custom-sort/custom-sort-header/custom-sort-header.component';
import { CustomPaginatorComponent } from './custom-paginator/custom-paginator.component';

@NgModule({
    declarations: [
        AppHeaderComponent,
        AppFooterComponent,
        AcceptableUsePolicyComponent,
        CookiePolicyComponent,
        DisclaimerComponent,
        PrivacyPolicyComponent,
        TermsOfUseComponent,
        ModalComponent,
        KebabMenuComponent,
        CustomMenuComponent,
        CustomMenuItemComponent,
        FreeSearchComponent,
        CustomDropdownListContainerComponent,
        CustomMultiSelectComponent,
        BreadcrumbComponent,
        CustomTextInputComponent,
        CustomTooltipComponent,
        MenuTabsComponent,
        CustomDropdownComponent,
        XYGraphComponent,
        CustomSortDirective,
        CustomSortHeaderComponent,
        CustomPaginatorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormComponentsModule,
        RouterModule
    ],
    exports: [
        AppHeaderComponent,
        AppFooterComponent,
        ModalComponent,
        KebabMenuComponent,
        CustomMenuComponent,
        CustomMenuItemComponent,
        FreeSearchComponent,
        CustomDropdownListContainerComponent,
        CustomMultiSelectComponent,
        BreadcrumbComponent,
        CustomTextInputComponent,
        CustomTooltipComponent,
        MenuTabsComponent,
        CustomDropdownComponent,
        XYGraphComponent,
        CustomSortDirective,
        CustomSortHeaderComponent,
        CustomPaginatorComponent
    ]
})
export class CoreModule {
}
